import set1 from '../image/setu/set1.png';
import set2 from '../image/setu/set2.png';
import set3 from '../image/setu/set3.png';
import set4 from '../image/setu/set4.png';
import set5 from '../image/setu/set5.png';
import set6 from '../image/setu/set6.png';
import set7 from '../image/setu/set7.png';
import set8 from '../image/setu/set8.png';
import set9 from '../image/setu/set9.png';


export const goods = [
   {
      id: 0,
      img: set1,
      name: 'Саломон сет',
      name_en: 'Salmon set',
      count: 1,
      weight: '1050 грам',
      quantity: '35 штук',
      cost: '2100 COM',
   },
   {
      id: 1,
      img: set2,
      name: 'Сет "5 Філадельфії"',
      name_en: 'Set "5 Philadelphias"',
      count: 1,
      weight: '250 грам',
      quantity: '45 штук',
      cost: '1800 COM',
   },
   {
      id: 2,
      img: set3,
      name: 'Філадельфія та лосось сет',
      name_en: 'Philadelphia and salmon set',
      count: 1,
      weight: '2050  грам',
      quantity: '25 штук',
      cost: '2500 COM',
   },
   {
      id: 3,
      img: set4,
      name: 'Сет "6 Філадельфій"',
      name_en: 'Set "6 Philadelphias"',
      count: 1,
      weight: '1050 грам',
      quantity: '15 штук',
      cost: '3100 COM',
   },
   {
      id: 4,
      img: set5,
      name: 'Топовий сет',
      name_en: 'Top set',
      count: 1,
      weight: '3150 грам',
      quantity: '65 штук',
      cost: '2120 COM',
   },
   {
      id: 5,
      img: set6,
      name: 'Камікадзе сет',
      name_en: 'Kamikaze set',
      count: 1,
      weight: '850 грам',
      quantity: '75 штук',
      cost: '2301 COM',
   },
   {
      id: 6,
      img: set7,
      name: 'Сет "4 Філадельфії"',
      name_en: 'Set "4 Philadelphias"',
      count: 1,
      weight: '650 грам',
      quantity: '15 штук',
      cost: '2800 COM',
   },
   {
      id: 7,
      img: set8,
      name: 'Філадельфії LOVE сет',
      name_en: 'Philadelphia LOVE set',
      count: 1,
      weight: '2150 грам',
      quantity: ' 10 штук',
      cost: '5100 COM',
   },
   {
      id: 8,
      img: set9,
      name: 'Якудза сет',
      name_en: 'Yakuza set',
      count: 1,
      weight: '820 грам',
      quantity: '40 штук',
      cost: '1200 COM',
   },
]